import React, { Fragment, useEffect, useState } from "react";
import { Form, Select, Input, DatePicker, TimePicker, Spin, InputNumber, Checkbox, Modal, Alert } from "antd";
import moment from "moment";
import { isEmpty, sortBy } from "lodash";
import { hasOwnProp } from "fullcalendar";

import CancelButton from "../../../components/buttons/CancelButton";
import ConfirmButton from "../../../components/buttons/ConfirmButton";
import ModalComponent from "../../../components/modalComponent/ModalComponent";
import {
  formatExpenseTypes,
  getExpenseTypeLabel,
  getSubtypesOfType,
  isExpenseSubTypetoBillToClient,
  getExpenseTypes,
  isExpenseSubTypeIsWithTva
} from "../utils/expense.utils";
import { fetchExpenseTypeApi, addExpenseApi, updateExpenseApi, handleError, uploadMedia } from "../api/api";
import { roles } from "../../../configs/constants";
import ReinvoiceInfos from "./Form/ReinvoiceInfos.form";
import TvaForm, { TVA_RESET } from "./Form/Tva.form";
import DisplayAttachments from "./DisplayAttachments.modal";
import { computeSumTvasAmount, getPriceMultipleTvaChecked } from "./Tva.utils";
const getLiterFuel = expense => {
  const itemLiterFuel = expense.extra_fields ? expense.extra_fields.find(item => item.label === "literFuel") : null;

  if (itemLiterFuel) return itemLiterFuel.value;
  return 0;
};

const ExpenseForm = ({
  userInfos,
  usersSectors,
  userRoleId,
  userClientsIds,
  fetchUsersSectors,
  expenseToModify = null,
  closeModal,
  form,
  token,
  requestFetch
}) => {
  // const [isErrorMsgDisplayed, setIsErrorMsgDisplayed] = useState(false);
  // const [isPriceInputDisabled, setIsPriceInputDisabled] = useState(false);
  const [isPriceDifferent, setIsPriceDifferent] = useState(false);
  const [fileModalIsVisible, setFileModalIsVisible] = useState(false);
  const [fileModalErrorVisible, setFileModalErrorVisible] = useState(false);
  const [fileModalErrorMsg, setFileModalErrorMsg] = useState("");
  const [selectedTypeId, setSelectedTypeId] = useState(expenseToModify ? expenseToModify.type.type : null);
  const [selectedSubtypeId, setSelectedSubtypeId] = useState(expenseToModify ? expenseToModify.type._id : null);
  const [date, setDate] = useState(expenseToModify ? moment(expenseToModify.date) : moment());
  const [isLoading, setIsLoading] = useState(false);
  const [isFuelInputDisplayed, setIsFuelInputDisplayed] = useState(selectedTypeId && selectedTypeId === "Carburant");
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [file, setFile] = useState("");
  const [observedPrice, setObservedPrice] = useState(0);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  const [displayAddress, setDisplayAddress] = useState(expenseToModify ? expenseToModify.type.set_address : null);
  const [files, setFiles] = useState([]);
  const selectedTypeLabel = getExpenseTypeLabel(expenseTypes, selectedTypeId);
  const subtypes = selectedTypeLabel ? getSubtypesOfType(expenseTypes, selectedTypeLabel, userRoleId) : [];
  const [isBillClientDisplayed, setIsBillClientDisplayed] = useState(
    isExpenseSubTypetoBillToClient(subtypes, selectedSubtypeId)
  );
  const displayTvas = isExpenseSubTypeIsWithTva(subtypes, selectedSubtypeId);
  const [literFuel, setLiterFuel] = useState(expenseToModify ? getLiterFuel(expenseToModify) : 0);
  const [userId, setUserId] = useState(userInfos && userInfos._id);
  const [userEmail, setUserEmail] = useState(userInfos && userInfos.email);
  const [isConfirmBtnDisabled, setIsConfirmBtnDisabled] = useState(true);

  useEffect(() => {
    setIsConfirmBtnDisabled(isEmpty(files) || (calculatedPrice == 0 && observedPrice == 0));
  }, [calculatedPrice, observedPrice, files]);

  useEffect(() => {
    if (form.getFieldValue("tva")) {
      const tvaFieldChecked = form.getFieldValue("tva").filter(item => item.checked);

      if (tvaFieldChecked && tvaFieldChecked.length === 1 && tvaFieldChecked[0].percentage === 0) {
        setIsPriceDifferent(true);
        setObservedPrice(0);
      } else if (tvaFieldChecked && tvaFieldChecked.length === 1 && tvaFieldChecked[0].percentage !== 0) {
        setObservedPrice(0);
        setIsPriceDifferent(false);
      }
    }
  }, [form.getFieldValue("tva")]);

  useEffect(() => {
    setIsBillClientDisplayed(isExpenseSubTypetoBillToClient(subtypes, selectedSubtypeId));
  }, [selectedSubtypeId]);

  useEffect(() => {
    fetchUsersSectors({
      match: {
        role_id: { $gt: userRoleId },
        "clients.id": userClientsIds ? userClientsIds : []
      }
    });
  }, []);

  const resetForm = () => {
    form.resetFields();
    setFile("");
    setFiles([]);
    setSelectedTypeId();
    setSelectedSubtypeId();
    setCalculatedPrice(0);
    setIsPriceDifferent(false);
    setObservedPrice(0);
  };
  const handleCreationModalCancel = () => {
    closeModal();
    resetForm();
  };

  useEffect(() => {
    if (selectedTypeId && selectedTypeId === "Carburant") setIsFuelInputDisplayed(true);
    else setIsFuelInputDisplayed(false);
    setIsPriceDifferent(!displayTvas);
  }, [selectedTypeId]);

  useEffect(() => {
    // setIsErrorMsgDisplayed(false);
    setFiles(expenseToModify ? expenseToModify.attachements : []);
    setSelectedTypeId(expenseToModify ? expenseToModify.type.type : null);
    setSelectedSubtypeId(expenseToModify ? expenseToModify.type._id : null);
    setLiterFuel(expenseToModify ? getLiterFuel(expenseToModify) : 0);
    setDisplayAddress(expenseToModify ? expenseToModify.type.set_address : null);
    setIsBillClientDisplayed(
      expenseToModify ? expenseToModify.reinvoice_infos && !isEmpty(expenseToModify.reinvoice_infos) : false
    );
    setCalculatedPrice(expenseToModify ? Number(expenseToModify.calculatedPrice) : 0);
    setIsPriceDifferent(
      expenseToModify ? expenseToModify.price && expenseToModify.price !== expenseToModify.calculatedPrice : false
    );
    setObservedPrice(expenseToModify ? expenseToModify.price : 0);
  }, [expenseToModify]);

  const handleCreationModify = () => {
    form.validateFields(async (err, expense) => {
      if (!err) {
        const tvasChecked = (displayTvas &&
          expense.tva &&
          expense.tva.filter(item => item.checked && item.amount_tva !== 0)) || [
          {
            percentage: 0,
            amount_tva: 0,
            checked: true,
            amount: observedPrice
          }
        ];

        try {
          expense.type = {
            _id:
              expenseToModify && expense.type === expenseToModify.type.subtype ? expenseToModify.type._id : expense.type
          };

          if (tvasChecked.length === 1 && tvasChecked[0].percentage === 0)
            expense.tva = [{ ...tvasChecked[0], amount: observedPrice }];
          else {
            expense.tva = tvasChecked.map(item => ({
              percentage: item.percentage,
              amount_tva: item.amount_tva,
              checked: item.checked
            }));
            if (
              isPriceDifferent &&
              observedPrice !== getPriceMultipleTvaChecked(tvasChecked) &&
              observedPrice - getPriceMultipleTvaChecked(tvasChecked) > 0
            )
              expense.tva = [
                ...expense.tva,
                {
                  percentage: 0,
                  // amount_tva: 0,
                  amount: observedPrice - getPriceMultipleTvaChecked(tvasChecked),
                  checked: true
                }
              ];
          }
          expense.attachements = files.map(file => {
            if (file && file.Key) return file.Key;
            return file;
          });
          expense.user_id = userId;
          expense.calculatedPrice = Number(calculatedPrice);
          if (isPriceDifferent) expense.price = Number(observedPrice);
          else expense.price = Number(calculatedPrice);
          if (!expense.hasOwnProperty("reinvoice_infos")) {
            expense.reinvoice_infos = {};
          }
          if (isFuelInputDisplayed)
            expense.extra_fields = [
              {
                id: 1,
                label: "literFuel",
                value: literFuel
              }
            ];
          if (displayAddress) {
            expense.set_address = true;
          } else {
            expense.set_address = false;
            expense.address = null;
            expense.city = null;
            expense.zip_code = null;
          }
          if (expenseToModify)
            await updateExpenseApi(
              {
                ...expense,
                _id: expenseToModify._id
              },
              token
            );
          else await addExpenseApi(expense, token);
          await requestFetch();
          resetForm();
          closeModal();
        } catch (e) {
          console.log("e", e);
          handleError(e);
        }
        // }
      }
    });
  };

  const { getFieldDecorator } = form;
  const fetchExpenseTypes = async () => {
    setIsLoading(true);

    try {
      const response = await fetchExpenseTypeApi(token);
      setExpenseTypes(formatExpenseTypes(response));
    } catch (e) {
      console.log("e", e, e.response);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchExpenseTypes();
  }, []);

  if (isLoading) return <Spin />;

  return (
    <div className="divide-y">
      <Form
        ref={formRef => {
          formRef = formRef;
        }}
        layout="vertical"
      >
        {!expenseToModify && userRoleId <= roles.MANAGER && (
          <div>
            <div className="font-bold my-4 mr-6">Utilisateur </div>
            <Select
              placeholder={"Choisir un utilisateur"}
              showSearch
              onChange={email => {
                setUserEmail(email);
                const user = [userInfos, ...usersSectors].find(u => email === u.email);
                if (user) setUserId([userInfos, ...usersSectors].find(u => email === u.email)._id);
              }}
              value={userEmail}
            >
              {userInfos &&
                usersSectors &&
                sortBy([userInfos, ...usersSectors], userData => userData.email).map(item => (
                  <Select.Option key={item._id} value={item.email}>
                    {item.email}
                  </Select.Option>
                ))}
            </Select>
          </div>
        )}
        <div className="my-6">
          <div className="font-bold my-4 mr-6">Catégorie </div>
          <Select
            placeholder={"Choisir une catégorie"}
            showSearch
            onChange={id => {
              setSelectedTypeId(id);
              setSelectedSubtypeId(null);
              form.setFieldsValue({
                type: undefined
              });
            }}
            value={selectedTypeId}
          >
            {sortBy(getExpenseTypes(expenseTypes, userRoleId), expenseType => expenseType.label).map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </div>

        <Form.Item label={"Type de frais"}>
          {getFieldDecorator("type", {
            initialValue: selectedSubtypeId,
            rules: [{ required: true, message: `Le type de frais doit être sélectionné.` }]
          })(
            <Select
              placeholder={"Choisir un type de frais"}
              disabled={!selectedTypeId}
              showSearch
              onChange={e => {
                if (subtypes) {
                  const itemId = subtypes.find(item => item._id === e);

                  setDisplayAddress(itemId.set_address);
                }
                setSelectedSubtypeId(e);
              }}
            >
              {subtypes.map(item => (
                <Select.Option key={item._id} value={item._id}>
                  {item.subtype}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>

        {isFuelInputDisplayed && (
          <Form.Item label="Fuel">
            {getFieldDecorator(`fuel`, {
              initialValue: literFuel,
              rules: [
                {
                  required: true,
                  message: `La quantité de carburant doit être renseigné`
                },
                {
                  validator: (_, value, callback) => {
                    if (value > 0) callback();
                    callback("La quantité de carburant doit être supérieure strictement 0");
                  }
                }
              ]
            })(
              <div className="mb-10 pl-10">
                <div className="font-bold mb-2 text-lg">Litre de carburant</div>
                <InputNumber
                  style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", marginRight: "8px" }}
                  min={0}
                  value={literFuel}
                  onChange={value => {
                    setLiterFuel(value);
                  }}
                />
              </div>
            )}
          </Form.Item>
        )}

        <Form.Item label="Date (et heure) indiquée(s) sur le ticket">
          {getFieldDecorator(`date`, {
            initialValue: expenseToModify ? moment(expenseToModify.date) : moment(),
            rules: [
              {
                required: true,
                message: `Cette date doit être choisie`
              }
            ]
          })(
            <div className="flex">
              <DatePicker
                defaultValue={date}
                onChange={e => {
                  const hoursToSet = moment(date).hour();
                  const minutesToSet = moment(date).minute();

                  setDate(
                    moment(e)
                      .hours(hoursToSet)
                      .minutes(minutesToSet)
                  );
                  form.setFieldsValue({
                    date: moment(e)
                      .hours(hoursToSet)
                      .minutes(minutesToSet)
                  });
                }}
                disabledDate={current => current && current.valueOf() > moment().endOf("day")}
              />
              <div className="ml-2">
                <TimePicker
                  defaultValue={date}
                  format="HH:mm"
                  onChange={e => {
                    const hoursToSet = moment(e).hour();
                    const minutesToSet = moment(e).minute();

                    setDate(
                      moment(date)
                        .hours(hoursToSet)
                        .minutes(minutesToSet)
                    );
                    form.setFieldsValue({
                      date: moment(date)
                        .hours(hoursToSet)
                        .minutes(minutesToSet)
                    });
                  }}
                />
              </div>
            </div>
          )}
        </Form.Item>
        {selectedSubtypeId && displayAddress && (
          <Fragment>
            <Form.Item label="Adresse">
              {getFieldDecorator(`address`, {
                initialValue: expenseToModify ? expenseToModify.address : null
              })(<Input placeholder={"Adresse"} />)}
            </Form.Item>
            <div className="flex">
              <div className="w-1/4">
                <Form.Item label="Code postal">
                  {getFieldDecorator(`zip_code`, {
                    initialValue: expenseToModify ? expenseToModify.zip_code : null
                  })(<InputNumber style={{ backgroundColor: "#f0f0f0", borderRadius: "11px" }} />)}
                </Form.Item>
              </div>
              <div className="w-9/12">
                <Form.Item label="Commune">
                  {getFieldDecorator(`city`, {
                    initialValue: expenseToModify ? expenseToModify.city : null,
                    rules: [
                      {
                        required: true,
                        message: `La commune doit être mentionnée`
                      }
                    ]
                  })(<Input placeholder={"Commune"} />)}
                </Form.Item>
              </div>
            </div>
          </Fragment>
        )}
        {displayTvas && (
          <Form.Item label="TVA">
            {getFieldDecorator("tva", { initialValue: TVA_RESET })(
              <TvaForm
                setCalculatedPrice={setCalculatedPrice}
                expenseToModify={expenseToModify}
                calculatedPrice={form.getFieldValue("calculatedPrice")}
                tvas={form.getFieldValue("tva")}
                form={form}
                setTvas={tva => form.setFieldsValue({ tva })}
              />
            )}
          </Form.Item>
        )}
        {displayTvas && (
          <Form.Item label="Montant TTC (calculé)">
            <InputNumber
              disabled={true}
              style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", marginRight: "8px" }}
              min={0}
              placeholder={""}
              value={calculatedPrice}
            />
            €
          </Form.Item>
        )}
        {displayTvas && selectedSubtypeId && (
          <div className="mb-8">
            <Checkbox
              disabled={computeSumTvasAmount(form.getFieldValue("tva")) <= 0}
              checked={isPriceDifferent}
              onClick={() => {
                const tvas = form.getFieldValue("tva");
                const tva0 = tvas.find(t => t.percentage === 0) || {};
                const tva0isChecked = tva0.checked;
                if (isPriceDifferent) {
                  setObservedPrice(0);
                }
                if (computeSumTvasAmount(tvas) <= 0 && !isPriceDifferent && !tva0isChecked) {
                  Modal.warning({
                    title: "Attention",
                    content: "Veuillez renseigner au moins un montant TVA ou sélectionner 'Pas de TVA sur le ticket'"
                  });
                  return;
                }
                setIsPriceDifferent(!isPriceDifferent);
              }}
            >
              Le prix TTC affiché sur le ticket est différent ?
            </Checkbox>
          </div>
        )}
        {isPriceDifferent && (
          <Form.Item label="Montant TTC (constaté)">
            <InputNumber
              style={{
                backgroundColor: "#f0f0f0",
                borderRadius: "11px",
                marginRight: "8px"
              }}
              min={0}
              placeholder={""}
              value={observedPrice}
              onChange={setObservedPrice}
            />
            €
          </Form.Item>
        )}
        {/*{isErrorMsgDisplayed && (*/}
        {/*  <div className="text-red-400 my-4">*/}
        {/*    Attention, le montant TTC est inférieur à la somme des prix TTC, tva incluse.*/}
        {/*  </div>*/}
        {/*)}*/}
        {/*<Form.Item label="TVA">{getFieldDecorator("tva", {})(<TvaForm expenseToModify={expenseToModify} />)}</Form.Item>*/}
        <div className="mt-6">
          {isBillClientDisplayed && (
            <Form.Item label="Client à refacturer">
              {getFieldDecorator(`reinvoice_infos`, {})(<ReinvoiceInfos />)}
            </Form.Item>
          )}
        </div>
        <Fragment>
          <ModalComponent
            title="Ajout d'une pièce jointe"
            showModal={fileModalIsVisible}
            closeModal={() => setFileModalIsVisible(false)}
          >
            <div>
              {fileModalErrorVisible && (
                <Alert style={{ marginBottom: 10 }} message={fileModalErrorMsg} type="error" closable />
              )}
              <div>Choisissez ci-dessous votre fichier.</div>
              <div style={{ marginTop: 15 }}>
                <input
                  accept=".jpeg,.jpg,.png,.pdf"
                  type="file"
                  name="file"
                  id="file"
                  onChange={e => {
                    let _files = e.target.files || e.dataTransfer.files;
                    if (!_files.length) return;
                    const file = _files[0];
                    if (file.size > 20 * 1024 * 1024) {
                      setFileModalErrorVisible(true);
                      setFileModalErrorMsg("Le fichier sélectionné est trop volumineux (max 20mo)");
                    } else {
                      setFile(file);
                      setFileModalErrorVisible(false);
                    }
                  }}
                  className="p-import-file"
                />
                <label htmlFor="file" className="p-import-btn">
                  {file ? file.name : "Choisir un fichier"}
                </label>
              </div>
              <div style={{ marginTop: 15 }}>
                <ConfirmButton
                  disabled={!file}
                  label={"Enregistrer"}
                  large={true}
                  onClick={async () => {
                    let fileMetaData;
                    try {
                      fileMetaData = await uploadMedia(file, token);
                      const newFiles = [...files];

                      newFiles.push(fileMetaData);
                      setFiles(newFiles);
                      setFileModalIsVisible(false);
                      setFile("");
                    } catch (e) {
                      setFileModalErrorVisible(true);
                      setFileModalErrorMsg("Une erreur est survenue");
                    }
                  }}
                />
              </div>
            </div>
          </ModalComponent>
          <div className="flex items-center justify-center my-6">
            <div
              className="cursor-pointer px-6 py-2 leading-5 rounded-full bg-orange-500 text-white"
              onClick={() => setFileModalIsVisible(true)}
            >
              Ajouter une pièce jointe
            </div>
          </div>
        </Fragment>
        <DisplayAttachments attachments={files.map(file => file)} />
        <div className="italic text-sm mb-4 flex justify-end">
          (La taille de la pièce jointe ne doit pas dépasser la limite maximale : 20 MO)
        </div>
      </Form>
      <div className="pt-6 flex justify-center">
        <CancelButton label="Annuler" large={true} onClick={handleCreationModalCancel} classes={"p-mrg-left-s"} />
        <div className="ml-2">
          <ConfirmButton
            disabled={isConfirmBtnDisabled}
            label={"Envoyer la demande"}
            large={true}
            onClick={handleCreationModify}
          />
        </div>
      </div>
    </div>
  );
};

export default Form.create()(ExpenseForm);



// WEBPACK FOOTER //
// src/modules/presence/components/Expense.form.js